import { AxiosError } from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { addToasts, unassignRepsFromPolygons, getTeamReps, selectTeam } from '../../redux';
const makeToasts = (response) => Object.entries(response.data).map(([polygonId, { success, errors }]) => ({
    type: success ? 'success' : 'error',
    message: success
        ? `Polygon #${polygonId} is unassigned.`
        : `Polygon #${polygonId} can't be unassigned.`,
    ...(errors && { details: errors.join('; ') }),
}));
const getSuccessfulPolygonIds = (response) => Object.entries(response.data).reduce((acc, [polygonId, { success }]) => success ? [...acc, Number(polygonId)] : acc, []);
function* handleUnassignRepsFromPolygons({ payload }) {
    const { polygonIds, callback } = payload;
    try {
        const response = (yield call(Api.unassignRepsFromPolygons, polygonIds));
        yield put(unassignRepsFromPolygons.success(response.data));
        yield put(addToasts(makeToasts(response.data)));
        yield call(callback, getSuccessfulPolygonIds(response.data));
    }
    catch (error) { // TODO: catch (error: AxiosError<UnassignRepsFromPolygonsFailurePayload> | Error) { ... } to get the type of the error
        yield put(unassignRepsFromPolygons.failure(error));
        if (error instanceof AxiosError && error.response?.data?.data) {
            const response = error.response;
            yield put(addToasts(makeToasts(response.data)));
            yield call(callback, getSuccessfulPolygonIds(response.data));
        }
    }
    finally {
        const { team } = (yield select(selectTeam));
        if (team?.id) {
            yield put(getTeamReps.request({ teamId: team.id }));
        }
    }
}
export default handleUnassignRepsFromPolygons;
